import Grid from '@material-ui/core/Grid'
import InputLabel from '@material-ui/core/InputLabel'
import Tooltip from '@material-ui/core/Tooltip'
import cn from 'classnames'
import styled, { ThemeProvider } from 'styled-components'

import theme from '../../utils/theme'

const LinkWrapper = styled.a`
  display: inline-block;
  font-weight: 500;
  line-height: 1;
  cursor: pointer;
  padding: 6px 0 7px;
  color: var(--gameday-body-textColor, ${theme.body.textColor});
  text-decoration: none;
  &.underline {
    text-decoration: underline;
  }
`

const FormLink = ({ className, children, isLabelInline, label, title, underline, ...rest }) => (
  <ThemeProvider theme={theme}>
    <Grid container direction={isLabelInline ? 'row' : 'column'}>
      {label && (
        <Grid container item xs={isLabelInline ? 3 : 12} alignContent="center">
          <InputLabel>{label}</InputLabel>
        </Grid>
      )}
      <Grid item xs={isLabelInline ? 9 : 12}>
        <Tooltip title={title} placement="right">
          <LinkWrapper className={cn({ underline }, className, 'custom-link')} {...rest}>
            {children}
          </LinkWrapper>
        </Tooltip>
      </Grid>
    </Grid>
  </ThemeProvider>
)

FormLink.defaultProps = {
  className: '',
  isLabelInline: false,
  title: '',
}

export default FormLink
